import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FormattedMessage, useIntl } from "react-intl";
import { range } from "../utils";

function AllSpaceStatus({ config, spaceStatus, setSpaceStatus }) {
  const [data, setData] = useState(null);
  const intl = useIntl();
  let formType = null;

  const formatData = () => {
    if (spaceStatus) {
      formType = config.SPACETYPE[`st_${spaceStatus.spacetype}`][0];
      let stateData = [];
      for (let i = 0; i < spaceStatus.deviceinfo.length; i++) {
        stateData[i] = {
          bookinfo: [],
          deviceinfo: spaceStatus.deviceinfo[i].deviceinfo,
          deviceid: spaceStatus.deviceinfo[i].deviceid,
          devicename: spaceStatus.deviceinfo[i].devicename,
          usetype: spaceStatus.deviceinfo[i].usetype,
          zoneid: spaceStatus.deviceinfo[i].zoneid,
        };
        const reformatted = [];
        for (let j = 0; j < spaceStatus.bookvalue.length; j++) {
          reformatted.push({
            booktitle:
              spaceStatus.booktime[j] && spaceStatus.booktime[j].split(":")[0],
            bookdate: spaceStatus.bookdate[j],
            booktime: spaceStatus.booktime[j] || null,
            bookvalue: spaceStatus.bookvalue[j],
            canbook: spaceStatus.deviceinfo[i].canbook[j],
            mybookvalue: spaceStatus.deviceinfo[i].mybookvalue[j],
            closeday: spaceStatus.deviceinfo[i].closeday[j],
            reason: spaceStatus.deviceinfo[i].reason[j],
          });
        }

        let temp = [];
        if (spaceStatus.spacetype === "26") {
          let morning = { key: "morning" };
          let noon = { key: "noon" };
          let night = { key: "night" };

          // 2-25-2022 新增，用在底下無法預約的時段要顯示的 booktime
          let periodTime = {};
          // 注意：由於陣列從小到大，以下早午晚的判斷邏輯很重要
          for (let i = 0; i < reformatted.length; i++) {
            if (parseInt(reformatted[i].bookvalue) === config.NOON_CONFIG[0]) {
              periodTime.morning = `${reformatted[0].booktime.split("~")[0]}~${
                reformatted[i - 1].booktime.split("~")[1]
              }`;
              periodTime.noon = `${reformatted[i].booktime.split("~")[0]}~`;
            } else if (
              parseInt(reformatted[i].bookvalue) === config.NOON_CONFIG[1]
            ) {
              periodTime.noon += reformatted[i].booktime.split("~")[1];
              periodTime.night = `${
                reformatted[i + 1].booktime.split("~")[0]
              }~${reformatted[reformatted.length - 1].booktime.split("~")[1]}`;
            }

            const bv = parseInt(reformatted[i].bookvalue);
            // 早上 bv < 下午開始
            if (bv < config.NOON_CONFIG[0]) {
              // 開始時間未定義 && 第一筆能預約的時間就是開始時間
              if (!morning.start && reformatted[i].canbook === 1) {
                morning.start = reformatted[i];
                // 若不是第一筆就紀錄開始時間，表示不是完整的一個時段
                if (i !== 0) morning.extraClass = "partial";
              }
              // 結束時間尚未定義 && 開始時間定義了 && 第一筆不能預約的時間的 前一筆 就是結束時間
              if (
                !morning.end &&
                morning.start &&
                reformatted[i].canbook === 0
              ) {
                morning.end = reformatted[i - 1];
                morning.extraClass = "partial";
              }
              // 迴圈跑完了 && 尚未定義結束時間 = 會有兩種情況
              if (bv === config.NOON_CONFIG[0] - 1 && !morning.end) {
                // 1. 開始時間已經定義了 = 表示陣列沒有不能預約的時間，所以整個陣列的最後一筆就是結束時間
                if (morning.start) morning.end = reformatted[i];
                // 2. 開始時間也未定義 = 表示陣列全部時間都不能預約，看看是不是自己預約的，是的話給 mybook
                if (reformatted[i].mybookvalue === 1)
                  morning.extraClass = "mybook";
              }

              // 晚上 bv > 下午結束
            } else if (bv > config.NOON_CONFIG[1]) {
              if (!night.start && reformatted[i].canbook === 1) {
                night.start = reformatted[i];
                if (
                  parseInt(reformatted[i - 1].bookvalue) !==
                  config.NOON_CONFIG[1]
                )
                  night.extraClass = "partial";
              }
              if (!night.end && night.start && reformatted[i].canbook === 0) {
                night.end = reformatted[i - 1];
                night.extraClass = "partial";
              }
              if (i === reformatted.length - 1 && !night.end) {
                if (night.start) night.end = reformatted[i];
                if (reformatted[i].mybookvalue === 1)
                  night.extraClass = "mybook";
              }

              // 剩下的皆為下午
            } else {
              if (!noon.start && reformatted[i].canbook === 1) {
                noon.start = reformatted[i];
                if (bv !== config.NOON_CONFIG[0]) noon.extraClass = "partial";
              }
              if (!noon.end && noon.start && reformatted[i].canbook === 0) {
                noon.end = reformatted[i - 1];
                noon.extraClass = "partial";
              }
              if (bv === config.NOON_CONFIG[1] && !noon.end) {
                if (noon.start) noon.end = reformatted[i];
                if (reformatted[i].mybookvalue === 1)
                  noon.extraClass = "mybook";
              }
            }
          }

          const periodArr = [morning, noon, night];

          // 整理完畢後將 早 午 晚 寫進 state
          temp = periodArr.map((r) => {
            // 開始結束都必須有資料，若無視為該時段無法預約
            if (!r.start || !r.end) {
              return {
                ...reformatted[0],
                bookvalue: "999," + Math.random(),
                booktitle: intl.formatMessage({ id: `appointment.${r.key}` }),
                booktime: periodTime[r.key],
                canbook: 0,
                extraClass: r.extraClass,
              };
            }
            return {
              ...r.start,
              booktitle: intl.formatMessage({ id: `appointment.${r.key}` }),
              booktime: `${r.start.booktime.split("~")[0]}~${
                r.end.booktime.split("~")[1]
              }`,
              bookvalue: range(
                parseInt(r.start.bookvalue),
                parseInt(r.end.bookvalue),
                1
              ).join(","),
              canbook: 1,
              extraClass: r.extraClass,
            };
          });
          // 如果來源陣列空的，直接將 temp 設為空陣列
          if (reformatted.length === 0) temp = [];
        } else {
          // 如果第一筆不是整點(bookvalue === 單數)，預先踢除獨立一筆，才進行陣列整理
          let firstRow = null;
          if (reformatted[0]?.bookvalue % 2 === 1) {
            firstRow = reformatted.shift();
            firstRow.extraClass =
              reformatted[0].mybookvalue === 1 ? "mybook" : "";
          }
          // 開始整理陣列
          temp = reformatted.map((row, index) => {
            // 兩筆合成一筆，所以 index % 2 === 1 的要拋棄
            const nextRow = reformatted[index + 1] || reformatted[index];
            if (index % 2 === 1) return null;
            // 檢查兩筆的可預約是否一樣，不一樣的只顯示可預約的時段(半小時)
            const canbookSame = row.canbook === nextRow.canbook;
            if (canbookSame) {
              // 一樣，合併兩筆
              const mybook = row.mybookvalue === 1;
              return {
                ...row,
                booktime: `${row.booktime.split("~")[0]}~${
                  nextRow.booktime.split("~")[1]
                }`,
                bookvalue: `${row.bookvalue},${nextRow.bookvalue}`,
                canbook: row.canbook,
                extraClass: mybook ? "mybook" : "",
              };
            } else {
              // 不一樣，檢查是那一筆能預約，只顯示該筆
              const canbookRow = row.canbook === 1 ? row : nextRow;
              return {
                ...canbookRow,
                // 當時段不完整加上特殊 class，未來可加顏色
                extraClass: "partial",
              };
            }
          });
          // 如果第一筆是有值的(表示第一筆不為整點，上方整理完畢後再將它加到陣列前面)
          if (firstRow) temp.unshift(firstRow);
        }
        stateData[i].bookinfo = temp.filter((r) => r !== null);
      }
      setData(stateData);
    }
  };

  useEffect(formatData, [spaceStatus]);

  return (
    <Modal
      size="xl"
      show={spaceStatus !== null}
      onHide={() => {
        setSpaceStatus(null);
      }}
      centered
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>
          <span>
            <FormattedMessage
              id={`global.spacetype.${spaceStatus?.spacetype}`}
            />
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {data === null ? (
            <Col sm={12}>Loading</Col>
          ) : data.length === 0 ? (
            <Col sm={12}>
              <FormattedMessage id="appointment.no_data" />
            </Col>
          ) : (
            data.map((row, index) => {
              const isMac = config.IS_MAC_DEVICEID.find(
                (elem) => elem === row.deviceid
              )
                ? true
                : false;
              const isChecked = false;
              return (
                <Col key={index} sm={12}>
                  <div className="d-flex align-items-center mb-1">
                    {row.deviceinfo !== "" && row.deviceinfo !== null ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{row.deviceinfo}</Tooltip>}
                      >
                        <i className="deviceinfo-icon information-icon"></i>
                      </OverlayTrigger>
                    ) : null}
                    {row.usetype === 4 ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <FormattedMessage id="appointment.accessibility_space" />
                          </Tooltip>
                        }
                      >
                        <i className="deviceinfo-icon accessibility-icon"></i>
                      </OverlayTrigger>
                    ) : null}
                    {isMac ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <FormattedMessage id="appointment.mac_device" />
                          </Tooltip>
                        }
                      >
                        <div style={{ margin: "-5px 0 0 -6px" }}>
                          <i className="deviceinfo-icon mac-icon"></i>
                        </div>
                      </OverlayTrigger>
                    ) : null}
                    <Form.Group className="device_radio">
                      <Form.Check
                        inline
                        id={`deviceRadio${index}`}
                        name="device"
                        value={row.deviceid}
                        type="radio"
                        defaultChecked={isChecked}
                        disabled={row.bookinfo.length === 0}
                        enabletobook="false"
                        label={
                          row.zoneid
                            ? `${intl.formatMessage({
                                id: `global.zoneid.${row.zoneid}`,
                              })}【${row.devicename}】 :`
                            : `【${row.devicename}】:`
                        }
                      />
                    </Form.Group>
                  </div>
                  <AllCheckArea
                    data={row.bookinfo}
                    formType={formType}
                    intl={intl}
                  />
                </Col>
              );
            })
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button
          className="bg_brand"
          variant="primary"
          onClick={() => setSpaceStatus(null)}
        >
          <FormattedMessage id="global.confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function AllCheckArea(props) {
  let prevDate = "";
  return (
    <Row className="deviceArea">
      {props.data === null ? (
        <Col sm={12}>Loading</Col>
      ) : props.data.length === 0 ? (
        <Col sm={12}>
          <FormattedMessage id="appointment.no_data" />
        </Col>
      ) : (
        props.data.map((row, index) => {
          let showDate = null;
          if (props.formType === "night" && prevDate !== row.bookdate) {
            showDate = row.bookdate;
            prevDate = row.bookdate;
          }
          return (
            <Col key={row.bookvalue} sm={6} md={4} lg={3} xl={2}>
              <Card
                border="dark"
                className={
                  row.canbook === 0
                    ? "disabled " + row.extraClass
                    : row.extraClass
                }
              >
                <Card.Body className="d-flex justify-content-around align-items-center">
                  <div className="text-center device_info">
                    <b className="d-block">{row.booktitle}</b>
                    <b>
                      {showDate}{" "}
                      {props.formType === "date" ? row.bookdate : row.booktime}
                    </b>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })
      )}
    </Row>
  );
}

export default AllSpaceStatus;
